import { memo, useCallback, useMemo, useState } from 'react';
import { DivTooltip, Menu } from '@wg/wows-react-uikit';

import settings from '~/settings';
import { t } from '~/helpers/localization';

import { TooltipBody } from '~/UIKit/components';

import styles from './LeagueSelector.scss';

import type { LeagueItem } from '~/types/declaration';

interface LeagueSelectorProps {
  items: LeagueItem[];
  selected: number;
  onLeagueChange: (league: number) => void;
}

const LeagueSelector = ({ items, selected, onLeagueChange }: LeagueSelectorProps) => {
  const [isMenuActive, setIsMenuActive] = useState(false);

  const itemSelected = useMemo(() => {
    return items.find((item) => item.value === selected) ?? items[0];
  }, [items, selected]);

  const onItemChange = useCallback(
    (league: number) => {
      setIsMenuActive(false);

      if (league !== selected) {
        onLeagueChange(league);
      }
    },
    [onLeagueChange, selected],
  );

  const onMenuBlur = useCallback(() => {
    setIsMenuActive(false);
  }, []);

  const onMenuToggled = useCallback((active: boolean) => {
    setIsMenuActive(active);
  }, []);

  const leagueContent = (
    <div>
      <img
        className={styles.leagueImage}
        src={`${settings.mediaPath}${itemSelected?.icons?.assembled_small ?? ''}`}
        alt=""
      />
      <span className={styles.leagueText}>{itemSelected?.content ?? null}</span>
    </div>
  );

  const wrappedContent = isMenuActive ? (
    leagueContent
  ) : (
    <DivTooltip tooltipBody={<TooltipBody withMouseClick>{t('Выбрать лигу для отображения статистики')}</TooltipBody>}>
      {leagueContent}
    </DivTooltip>
  );

  return (
    <div className={styles.container}>
      <Menu
        items={items}
        itemSelected={itemSelected?.value ?? ''}
        onItemChange={onItemChange}
        onMenuBlur={onMenuBlur}
        onMenuToggled={onMenuToggled}
      >
        {wrappedContent}
      </Menu>
    </div>
  );
};

export default memo(LeagueSelector);
